// SHCT-582 — the P-4 notice, raised once.
//
// PRD 21 v2.14 §7.4 gives 서버 거부 exactly one channel and one follow-up: 토스트(error) carrying
// `접근 권한이 없습니다.`, 후속 동작 없음, **화면 유지**. That differs from P-1 (entry block → modal
// → home) on purpose: an entry block needs somewhere to send the operator back to, while a 403
// rejects one request and nothing else, so redirecting would throw away the rest of their screen.
//
// The guard is what makes it usable from a render path: a refetching query re-renders, and one
// toast per attempt is not what §7.4 describes.

import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { toast } from './useToast';

export function usePermissionDeniedToast(active: boolean): void {
  const { t } = useTranslation('common');
  const shown = useRef(false);

  useEffect(() => {
    if (!active || shown.current) return;
    shown.current = true;
    toast.error(t('gate.noPermission.notice'));
  }, [active, t]);
}
